import { Menu as ChakraMenu } from '@chakra-ui/react-v2';
import type { MenuProps as ChakraMenuProps } from '@chakra-ui/react-v2';
import maxSize from 'popper-max-size-modifier';

import { MenuProvider } from './utils/MenuContext';

export type MenuProps = ChakraMenuProps;

export const Menu = ({
  size = 'lg',
  children,
  modifiers = [],
  gutter = 8,
  offset,
  ...restProps
}: MenuProps) => {
  return (
    <MenuProvider value={{ size }}>
      <ChakraMenu
        size={size}
        gutter={gutter}
        offset={offset}
        modifiers={[
          maxSize,
          {
            name: 'applyMaxSize',
            enabled: true,
            phase: 'beforeWrite',
            requires: ['maxSize'],
            fn({ state }) {
              const { popper } = state.elements;
              const { height } = state.modifiersData.maxSize;
              popper.style.setProperty(
                '--popper-max-height',
                `${height - (offset?.[0] ?? gutter)}px`,
              );
            },
          },
          ...modifiers,
        ]}
        {...restProps}
      >
        {children}
      </ChakraMenu>
    </MenuProvider>
  );
};
